import { handleActions } from 'redux-actions'

import { SELECTED_TAB_PARAM, WORKSPACES_TAB_VALUES } from './constants'

const queryParams = new URLSearchParams(window.location.search)
const tabValue = queryParams.get(SELECTED_TAB_PARAM)?.toLowerCase() || ''

export const defaultState = {
  selectedAssortments: {},
  brandNoteFilter: tabValue === WORKSPACES_TAB_VALUES.BRAND_NOTES,
  archivedFilter: tabValue === WORKSPACES_TAB_VALUES.ARCHIVED,
}

const reducer = handleActions(
  {
    'WORKSPACE_LIST/RESET_SELECTED_ASSORTMENTS': (state) => ({
      ...state,
      selectedAssortments: defaultState.selectedAssortments,
    }),
    'WORKSPACE_LIST/BULK_TOGGLE_WORKSPACES': (
      state,
      { payload: assortmentIds },
    ) => {
      const selectedAssortments = {}
      assortmentIds.forEach((id) => (selectedAssortments[id] = true))
      return {
        ...state,
        selectedAssortments,
      }
    },
    'WORKSPACE_LIST/TOGGLE_ASSORTMENT': (state, { payload: assortmentId }) => {
      const { selectedAssortments } = state

      const assortmentIsSelected = assortmentId in selectedAssortments

      if (assortmentIsSelected) {
        const {
          [assortmentId]: _isAssortmentSelected,
          ...selectionWithoutPayload
        } = selectedAssortments
        return {
          ...state,
          selectedAssortments: selectionWithoutPayload,
        }
      }

      return {
        ...state,
        selectedAssortments: {
          ...selectedAssortments,
          [assortmentId]: true,
        },
      }
    },
    'WORKSPACE_LIST/TOGGLE_BRAND_NOTE_FILTER': (state) => ({
      ...state,
      brandNoteFilter: !state.brandNoteFilter,
    }),
    'WORKSPACE_LIST/SET_BRAND_NOTE_FILTER': (
      state,
      { payload: brandNoteFilter },
    ) => ({
      ...state,
      brandNoteFilter,
    }),
    'WORKSPACE_LIST/SET_ARCHIVED_FILTER': (
      state,
      { payload: archivedFilter },
    ) => ({
      ...state,
      archivedFilter,
    }),
  },
  defaultState,
)

export default reducer
